import { useMemo } from 'react';

import { CustomCheckboxInteface } from '../../core/models';
import { Icon } from '../Icon/Icon';

interface Props {
  id: string;
  name: string;
  info?: string;
  label?: string;
  invalidMessage?: string;
  input: CustomCheckboxInteface;
}

function CustomCheckbox({ id, name, info, label, invalidMessage, input }: Props) {
  const error = useMemo(
    () => (!input.showError ? '' : !input.isValid ? 'invalid' : ''),
    [input.showError, input.isValid],
  );

  return (
    <div className={`input input--checkbox${!error ? '' : ' error'}`}>
      {!label ? null : (
        <label className="input__checkbox-label" htmlFor={id}>
          {label}
          <input
            id={id}
            type="checkbox"
            name={name}
            checked={input.checked}
            onChange={input.onChange}
            className="input__checkbox"
          />
          {!input.checked ? null : <Icon.Checkmark className="input__checkmark-icon" />}
          <span className="input__checkmark" />
        </label>
      )}
      {!info ? null : <div className="input__info caption">{info}</div>}
      {!error ? null : (
        <div className="input__error">
          <span>{error === 'invalid' ? invalidMessage : ''}</span>
        </div>
      )}
    </div>
  );
}

export default CustomCheckbox;
